import React, { useEffect, useState } from 'react'
import Avatar, { ConfigProvider } from 'react-avatar';
import { useCookies } from 'react-cookie'
import { useNavigate, useParams } from 'react-router-dom';
import {getUser, updateProfile, changePassword} from '../services/UserService'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';


export default function MyAccount(){

    const [user, setUser] = useState([])
    const [cookies, setCookies, removeCookies] = useCookies()
    const [profileOpen, setProfileOpen] = useState(false);
    const [changePasswordOpen, setChangePasswordOpen] = useState(false);
    const [errMsg, setErrMsg] = useState('')
    const [successMsg, setSuccessMsg] = useState('')
    const [currPass, setCurrentPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [confirmPass, setConfirmPass] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [isLocalUser, setIsLocalUser] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const navigate = useNavigate()
    const {id} = useParams()

    const handleChangePasswordClickOpen = () => {
        setChangePasswordOpen(true);
    };
  
    const handleChangePasswordClose = () => {
        setChangePasswordOpen(false);
    };

    const handleUpdateProfileClickOpen = () => {
        setProfileOpen(true);
      };
    
      const handleUpdateProfileClose = () => {
        setProfileOpen(false);
      };

      const createTokenHeader = () =>{
        if(!cookies['accessToken']){
            navigate('/login')
            return
        }
        const token = cookies['accessToken'].access_token
        const _headers = {"Authorization" : `Bearer ${token}`}
        return _headers
    }
    
    function getHeaderObjectForFetchtingUser(){

      if(cookies['accessToken']){
        const token = cookies['accessToken'].access_token
        const _header = `Bearer ${token}`
        return [true, _header]
      }
      return [false, null]
    }

    useEffect(()=>{
        setIsLoading(true)
        const [isHeaderPresent, header] = getHeaderObjectForFetchtingUser()
        const _headers = {
          isHeaderPresent: isHeaderPresent,
          header: header
        }  
        getUser(id, _headers)
        .then((res)=>{
            console.log(res.data)
            setUser(res.data.user)
            setIsLocalUser(res.data.isLocalUserLoggedIn)
            setIsLoading(false)
        })
        .catch((err)=>{
            console.log(err.response.data)
            setIsLoading(false)
            if(err.response.status == 404){
                return navigate("/")
            }else{
                console.log(err.response.data)
            }
        })
    },[])


    const handleProfileUpdate=()=>{
        setErrMsg("")

        const _headers = createTokenHeader()

        const updatedProfile = {
            firstName: firstName,
            lastName: lastName
        }

        updateProfile(updatedProfile, _headers)
        .then((res)=>{
            console.log(res)
            if(res.status == 200){
                setProfileOpen(false);
                window.location.reload();
            }
        })
        .catch((err)=>{
            if(err.response.status == 400){
                setErrMsg(err.response.data)
            }else{
                setErrMsg("Servie Unavailable")
            }
            console.log(err.response.data)
        })

        setFirstName('')
        setLastName('')
    }

    const handlePasswordUpdate=(event)=>{
        setErrMsg("")
        const _headers = createTokenHeader()

        if(newPass !== confirmPass){
            setErrMsg("New Password and Confirm Password do not match")
            return
        }

        const updatedPassword = {
            password: currPass,
            newPassword: newPass
        }

        changePassword(updatedPassword, _headers)
        .then((res)=>{
            console.log(res)
            if(res.status == 200){
                setChangePasswordOpen(false)
                window.location.reload();  
            }
        })
        .catch((err)=>{
            if(err.response.status == 403){
                setErrMsg(err.response.data)
            }else{
                setErrMsg("Servie Unavailable")
            }
            console.log(err.response.data)
            return
        })    
        setCurrentPass('')
        setNewPass('')
        setConfirmPass('')  
    }

    return (
        <div style={{marginTop: '2em'}}>
            {isLoading && <CircularProgress />}
             {!isLoading &&
             <div>
            <ConfigProvider colors={['red', 'green', 'blue']}>
                <Avatar name={user.firstName + " " + user.lastName} alt={user.firstName + " " + user.lastName} sx={{ width: 56, height: 56 }}/>
            </ConfigProvider>
            <Card sx={{ minWidth: 275, marginTop: 5}}>
                <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Joined on: {user.createdOn}
                    </Typography>
                    <Typography variant="h5" component="div">
                    Name: {user.firstName + " " + user.lastName}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    Email: {user.userEmail}
                    </Typography>
                    {isLocalUser &&
                    <div>
                        <div onClick={handleUpdateProfileClickOpen}>
                            <Button size="small" >Update Profile</Button>
                        </div>
                        <div onClick={handleChangePasswordClickOpen}>
                            <Button size="small" variant="outlined">
                                Change Password</Button>
                        </div>
                    </div>}
                </CardContent>
            </Card>
            </div>
            }
            {isLocalUser &&
            <div>
            <Dialog open={profileOpen} onClose={handleUpdateProfileClose}>
                <DialogTitle>Update Profile</DialogTitle>
                <DialogContent>
                {errMsg != '' && <div className='alert alert-danger'>{errMsg}</div>}
                {successMsg != '' && <div className='alert alert-success'>{successMsg}</div>} 
                <TextField
                    autoFocus
                    margin="dense"
                    id="firstName"
                    label="First Name"
                    type="text"
                    value={firstName}
                    onChange={e=> setFirstName(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="lastName"
                    label="Last Name"
                    type="text"
                    value={lastName}
                    onChange={e=> setLastName(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleUpdateProfileClose}>Cancel</Button>
                <Button onClick={handleProfileUpdate}>Update</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={changePasswordOpen} onClose={handleChangePasswordClose}>
                <DialogTitle>Change Password</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    To change to password, please enter your original password
                </DialogContentText>
                {errMsg != '' && <div className='alert alert-danger'>{errMsg}</div>}
                {successMsg != '' && <div className='alert alert-success'>{successMsg}</div>} 
                <TextField
                    autoFocus
                    margin="dense"
                    id="curr_password"
                    label="Current Password"
                    type="password"
                    value={currPass}
                    onChange={e=> setCurrentPass(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="new_password"
                    label="New Password"
                    type="password"
                    value={newPass}
                    onChange={e=> setNewPass(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="confirm_password"
                    label="Confirm Password"
                    type="password"
                    value={confirmPass}
                    onChange={e=> setConfirmPass(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleChangePasswordClose}>Cancel</Button>
                <Button onClick={handlePasswordUpdate}>Save</Button>
                </DialogActions>
            </Dialog>
            </div>
            }
        </div>
      );
}